

<button 
type="button" 
class="link-hover btn-move-top" 
arial-label="go to top of page" 
(click)="moveTop()">
    <ng-content></ng-content>
</button>